import type { TKey } from "@/lib/i18n";
import { PRESET_SETS } from "@/lib/campaigns-table";

/**
 * The board's four built-in reports (доска Report: «По объявлениям · По гео и
 * часам · Ленды · Офферы по партнёркам»). They are not rows in report_views:
 * they are the screen's own starting points; a buyer's saved reports
 * (ListReportViews surface=report) follow them.
 */
export interface BuiltinView {
  id: "ads" | "time" | "landers" | "offers";
  label: TKey;
  dims: string[];
  /** A column set, or the view's own columns. */
  set?: string;
  metrics?: string[];
}

export const BUILTIN_VIEWS: BuiltinView[] = [
  { id: "ads", label: "rep.view.ads", dims: ["campaign", "creative", "country"], set: "money" },
  { id: "time", label: "rep.view.time", dims: ["country", "weekday", "hour"], metrics: ["clicks", "leads", "cr", "conversions", "profit", "roi"] },
  { id: "landers", label: "rep.view.landers", dims: ["landing", "campaign"], metrics: ["visits", "clicks", "cta_clicks", "lp_ctr", "leads", "lander_cr", "approve_rate", "revenue", "epc", "profit"] },
  { id: "offers", label: "rep.view.offers", dims: ["network", "offer"], metrics: ["leads", "conversions", "conversions_hold", "rejected", "approve_rate", "outcome", "revenue"] },
];

export const DEFAULT_VIEW = BUILTIN_VIEWS[0]!;

export function builtinKeys(v: BuiltinView): string[] {
  return v.metrics ?? PRESET_SETS[(v.set ?? "money") as keyof typeof PRESET_SETS];
}
